/*
 * Browser-only Google/Apple sign-in for the editor.
 *
 * The editor must not navigate away (it would lose unsaved edits), so instead of
 * a full-page redirect we open a same-origin popup to /auth/{provider}/redirect
 * and let the backend callback page talk back to us. This mirrors the Instagram
 * idiom (window.instagramSDK): the popup page runs
 *   window.opener.flxSocialAuth.onResult({ ok, mode, user })
 * and we forward the result to the caller's callback.
 *
 * Inside the Flutter webview (fx.get("flutter") truthy) the native auth modal is
 * used instead, so this popup path is never triggered there.
 */
window.flxSocialAuth = {

    _pending: null,
    newWindow: null,

    // Opens the provider popup. options: { creationid, accountid, onResult }
    login(provider, options)
    {
        this._pending = options || {};

        let url = '/auth/' + provider + '/redirect?popup=1';
        if (this._pending.creationid) url += '&creationid=' + this._pending.creationid;
        if (this._pending.accountid) url += '&accountid=' + this._pending.accountid;

        this.createPopup(url);
    },

    createPopup(url)
    {
        this.closePopup();

        let tools =
            'status=no,resizable,toolbar=no,location=no,scrollbars=yes,width=500,height=650,left=500,top=100';

        this.newWindow = window.open(url, 'FlxSocialAuth', tools);

        if (!this.newWindow)
            alert('Veuillez autoriser les popups (ouverture de fenêtres) pour continuer.');
        else
            this.newWindow.focus();
    },

    closePopup()
    {
        if (this.newWindow != null && !this.newWindow.closed) this.newWindow.close();
        this.newWindow = null;
    },

    // Called by the same-origin backend callback page via
    // window.opener.flxSocialAuth.onResult(...).
    onResult(resp)
    {
        this.closePopup();

        let callback = this._pending && this._pending.onResult;
        this._pending = null;

        if (callback) callback(resp);
    },
};
